module.exports = __webpack_public_path__ + "assets/img/favicon/apple-icon-114x114.b09b3ba3235b39d7b1ee5ebe02fa5a66.png";